import { Designation } from "../types"
import { AmountInputDisplay } from "./display"
import { useDonationFormContext } from "../hooks/useDonationFormContext"
import { designationTotal } from "../utils/designationTotal"

export function AmountInput({ designations }: { designations: Designation[] }) {
  if (designations.length > 1) {
    return <ReadOnlyTotalDesignationAmount {...{ designations }} />
  } else {
    return <FirstDesignationAmountInput designation={designations[0]} />
  }
}

type FirstDesignationAmountInputProps = {
  designation: Designation
}
function FirstDesignationAmountInput(props: FirstDesignationAmountInputProps) {
  const { dispatch } = useDonationFormContext()
  const {
    designation: { fundId, amount },
  } = props

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch({
      type: "UPDATE_DESIGNATION_AMOUNT",
      fundId,
      amount: e.target.value,
    })
  }

  return <AmountInputDisplay {...{ amount, onChange }} />
}

type ReadOnlyTotalDesignationAmountProps = {
  designations: Designation[]
}
function ReadOnlyTotalDesignationAmount(
  props: ReadOnlyTotalDesignationAmountProps,
) {
  const { designations } = props
  const amount = designationTotal(designations).toString()
  return <AmountInputDisplay {...{ amount }} readOnly={true} />
}
